export default __webpack_public_path__ + "static/media/rating_7.65e4fb20.svg";